import type { MonitoringConfig } from "@climatepartner/app-shell/monitoring";

import { excludeUser } from "./exclude-user";
import { MONITORING_MODULES } from "./modules";
import { toRumViewName } from "./rum-view-name";
import { addViewedAccount } from "./viewed-account";

export const monitoringConfig: MonitoringConfig = {
  service: "cfc-frontend",
  version: import.meta.env.VITE_GIT_SHA,
  credentials: {
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
  },
  viewName: toRumViewName,
  allowedTracingUrls: [
    import.meta.env.VITE_SERVICE_BASE_URL,
    import.meta.env.VITE_FPC_BASE_URL,
    import.meta.env.VITE_PCF_SERVICE_BASE_URL,
    import.meta.env.VITE_QUESTIONNAIRE_BASE_URL,
    import.meta.env.VITE_HOME_SCREEN_URL,
  ],
  excludeUser,
  modules: MONITORING_MODULES,
  beforeSend: addViewedAccount,
  sessionReplaySampleRate: 100,
  logs: {
    // SDK v7 no longer forwards console.error through forwardErrorsToLogs alone.
    forwardConsoleLogs: ["error"],
  },
  unsafeInitOptions: {
    // Unnamed clicks keep their text label until key targets carry data-dd-action-name.
    enablePrivacyForActionName: false,
  },
};
